import { Container, Box, Card } from '@mui/material';
import React from 'react';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CardActionArea from '@mui/material/CardActionArea';
import { useNavigate } from 'react-router-dom';
import BaseTypography from '../../Utilities/BaseTypography';

export default function ArticleLinkBox() {
  const navigate = useNavigate();

  return (
    <Container
      sx={{
        backgroundImage: `url('/images/article-banner-bg.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '700px',
        paddingTop: '15px',
        paddingBottom: '15px',
        position: 'relative',
      }}
    >
      <BaseTypography type='heading' sx={{ fontSize: '34px', textAlign: 'center', pb: 5 }}>Article</BaseTypography>
      <Box sx={{ display: "flex", flexDirection: 'row', gap: 3, flexWrap: 'wrap', justifyContent: 'center' }}>
        <Card sx={{ maxWidth: 450 }}>
          <CardActionArea onClick={() => navigate('/8d-problem-solving')}>
            <CardMedia
              component="img"
              height="200"
              image="images/8d-image.png"
              alt="8D Problem-Solving Process"
              sx={{ width: '100%', height: '100%', borderRadius: '30px', p: 2 }}
            />
            <CardContent>
              <BaseTypography type='heading' sx={{ fontSize: '18px', py: 1 }}>
                8D Problem-Solving Process: A Comprehensive Approach to Quality Management
              </BaseTypography>
              <BaseTypography sx={{ fontSize: '18px', py: 1, }}>
                In the world of engineering, manufacturing, and other quality-critical industries, resolving product or process-related issues effectively is
              </BaseTypography>
              <BaseTypography type='label' sx={{ fontWeight: '400', py: 1, color: '#898989', fontStyle: 'italic' }}>
                Posted on: 2 May 2025
              </BaseTypography>
            </CardContent>
          </CardActionArea>
        </Card>
        <Card sx={{ maxWidth: 450 }}>
          <CardActionArea onClick={() => navigate('/homearticle')}>
            <CardMedia
              component="img"
              height="200"
              image="images/ncpro_v1.png"
              alt="8D Problem-Solving Process"
              sx={{ width: '100%', height: '100%', borderRadius: '30px', p: 2 }}
            />
            <CardContent>
              <BaseTypography type='heading' sx={{ fontSize: '18px', py: 1 }}>
                Non-Conformity Pro Quality control & management
              </BaseTypography>
              <BaseTypography sx={{ fontSize: '18px', py: 1, }}>
                GB NC pro is a software tool that captures and analyses engineering quality issues, ensuring compliance and preventing future problems through detailed documentation and analysis
              </BaseTypography>
              <BaseTypography type='label' sx={{ fontWeight: '400', py: 1, color: '#898989', fontStyle: 'italic' }}>
                Posted on: 2 Jan 2026
              </BaseTypography>
            </CardContent>
          </CardActionArea>
        </Card>
      </Box>
    </Container>
  )
}
